import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, createLazyComponent, type LazyComponent } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import('./lazyIndex'),
    {
        name: 'OwaOfficeaiCopilotChatShared',
    }
);

export const lazyOpenCopilotChatAndAddPrompt: LazyAction<
    typeof lazyIndex.openCopilotChatAndAddPrompt,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openCopilotChatAndAddPrompt);
export const lazyAddChatInitialConversation: LazyAction<
    typeof lazyIndex.addChatInitialConversation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addChatInitialConversation);

export const lazyOpenCopilotChatAndSubmitPodcastRequest: LazyAction<
    typeof lazyIndex.openCopilotChatAndSubmitPodcastRequest,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openCopilotChatAndSubmitPodcastRequest);

export const LazyCopilotChatImagePopup: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.CopilotChatImagePopup
);

export { CopilotChatSources } from './utils/logCopilotChatEntrypoint';
